import { RouteRecordRaw } from 'vue-router';

import BaseLayout from '@/layouts/base-layout.vue';
import { redirectLogged } from '@/router/middlewares/redirectLogged';

// const isDemoMode = process.env.VUE_APP_DEMO_MODE === 'true';

const SignIn = () => import('@/modules/entrance/pages/sign-in.vue');

const IsBlockedOrBanned = () => import('@/modules/entrance/pages/is-blocked-or-banned.vue');

const ENTRANCE_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'sign-in',
    name: 'sign-in-manual',
    component: SignIn,
    meta: {
      disableGuard: true,
      middleware: [
        redirectLogged,
      ],
      layout: {
        componentName: 'BaseClosableLayout',
      },
    },
  },
  {
    path: 'banned',
    name: 'is-banned',
    component: IsBlockedOrBanned,
    meta: {
      disableGuard: true,
      middleware: [
        redirectLogged,
      ],
      layout: {
        componentName: 'BaseClosableLayout',
      },
    },
  },
  {
    path: 'blocked',
    name: 'is-blocked',
    component: IsBlockedOrBanned,
    meta: {
      disableGuard: true,
      middleware: [
        redirectLogged,
      ],
      layout: {
        componentName: 'BaseClosableLayout',
      },
    },
  },
];

export const ENTRANCE: RouteRecordRaw = {
  path: '/',
  name: 'entrance',
  component: BaseLayout,
  props: {
    fetchProfile: false,
  },
  // redirect: isDemoMode ? ENTRANCE_CHILDREN[0] : ENTRANCE_CHILDREN[1],
  redirect: ENTRANCE_CHILDREN[0],
  children: ENTRANCE_CHILDREN,
};
